<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header">
              <div class="header-top">
                <h5 class="m-0"><b>กิจกรรมของฉัน</b></h5>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="text-align: left">ชื่อกิจกรรม</th>
                    <th style="text-align: left">สัญญาว่าจ้าง</th>
                    <th style="text-align: left">วันที่จัดกิจกรรม</th>
                    <th style="text-align: left">วันที่เปิดระบบสมัคร</th>
                    <th style="text-align: left">วันที่ปิดรับระบบสมัคร</th>
                    <th style="text-align: left">รายงาน</th>
                    <th style="text-align: left">ตรวจสอบบิบ</th>
                    <th style="text-align: left">สุ่มรายชื่อผู้สมัคร</th>
                    <th style="text-align: center">แก้ไข</th>
                  </tr>
                </thead>
                <tbody v-if="this.is_loading === 'Y'">
                  <tr>
                    <td colspan="10">
                      <div class="d-flex justify-content-center">
                        <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="this.data_my_order.length !== 0">
                  <tr v-for="item in this.data_my_order" :key="item">
                    <td style="text-align: left">{{ item.title }}</td>
                    <td style="text-align: left">
                      <a v-if="item.payment_method === 'OPN'" :href="'/dashboard-organizer/' + item.event_key + '/contract'">สัญญาว่าจ้าง</a>
                      <span v-else>-</span>
                    </td>
                    <td style="text-align: left">{{ item.event_date_text }}</td>
                    <td style="text-align: left">{{ item.registration_start_text }}</td>
                    <td style="text-align: left">{{ item.registration_end_text }}</td>
                    <td style="text-align: left"><a :href="'/dashboard-organizer/' + item.event_key">รายงานผู้สมัคร</a></td>
                    <td style="text-align: center" v-if="item.is_enable_checkbib_function ==='Y'"><a :href="'/checkbib-organizer/' + item.event_key">CheckBIB</a></td>
                    <td style="text-align: center" v-if="item.is_enable_checkbib_function ==='N'">-</td>
                    <td style="text-align: left">
                      <a v-if="item.is_lucky_draw === 'Y'" target="_blank" :href="'/dashboard-organizer/' + item.event_key + '/lucky-draw'">สุ่มรายชื่อผู้สมัคร</a>
                      <span v-else>-</span>
                    </td>
                    <td style="text-align: center">
                      <a href="javascript:void(0)" @click="open_edit_modal(item)">แก้ไข</a>
                    </td>
                  </tr>
                </tbody>
                <tbody>

                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Modal แก้ไขข้อมูลกิจกรรม -->
  <div v-if="edit_modal.show" class="modal fade show d-block" tabindex="-1" style="background: rgba(0, 0, 0, 0.5)">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><b>แก้ไขข้อมูลกิจกรรม</b></h5>
          <button type="button" class="btn-close" @click="close_edit_modal()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">ชื่อกิจกรรม</label>
            <input type="text" class="form-control" v-model="edit_modal.title" />
          </div>
          <div class="mb-3">
            <label class="form-label">วันที่จัดกิจกรรม</label>
            <input type="date" class="form-control" v-model="edit_modal.event_date" />
          </div>
          <div class="mb-3">
            <label class="form-label">วันที่เปิดระบบสมัคร</label>
            <div class="row g-2">
              <div class="col-7">
                <input type="date" class="form-control" v-model="edit_modal.registration_start_date" />
              </div>
              <div class="col-5">
                <input type="time" class="form-control" v-model="edit_modal.registration_start_time" step="60" lang="en-GB" />
              </div>
            </div>
            <small class="text-muted">รูปแบบเวลา 24 ชั่วโมง</small>
          </div>
          <div class="mb-3">
            <label class="form-label">วันที่ปิดรับระบบสมัคร</label>
            <div class="row g-2">
              <div class="col-7">
                <input type="date" class="form-control" v-model="edit_modal.registration_end_date" />
              </div>
              <div class="col-5">
                <input type="time" class="form-control" v-model="edit_modal.registration_end_time" step="60" lang="en-GB" />
              </div>
            </div>
            <small class="text-muted">รูปแบบเวลา 24 ชั่วโมง</small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" :disabled="edit_modal.is_saving === 'Y'" @click="close_edit_modal()">ยกเลิก</button>
          <button type="button" class="btn btn-primary" :disabled="edit_modal.is_saving === 'Y'" @click="save_edit_event()">
            {{ edit_modal.is_saving === 'Y' ? 'กำลังบันทึก...' : 'บันทึก' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";
export default {
  components: {
    welcomecard,
  },
  data() {
    return {
      token: null,
      is_loading: "N",
      data_my_order: [],
      edit_modal: {
        show: false,
        is_saving: "N",
        event_key: "",
        title: "",
        event_date: "",
        registration_start_date: "",
        registration_start_time: "",
        registration_end_date: "",
        registration_end_time: ""
      }
    }
  },
  async mounted() {
    this.token = localStorage.getItem("_rr_token");
    if(this.token !== null){
      this.load_my_order();
    }else{
      //alert("เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง")
      this.$router.push("/auth/login");
    }
   
  },
  methods: {
    async load_my_order() {
      this.is_loading = "Y"
      this.data_my_order = [];
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      const res = await axios.post("v1/organizer/event", null, { headers });
      //console.log("res:", res)
      if (res.data.status === 'success') {
        this.data_my_order = res.data.body
        this.is_loading = "N"
      } else {

        alert("พบข้อผิดพลาด")
        this.is_loading = "N"
      }
    },
    toDateInput(value) {
      // แปลงค่าวันที่จาก API เป็นรูปแบบ YYYY-MM-DD สำหรับ input type="date"
      if (!value) return "";
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value).substring(0, 10);
      const pad = (n) => String(n).padStart(2, "0");
      return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
    },
    splitDateTimeParts(value) {
      // แปลงค่า datetime จาก API เป็น { date: YYYY-MM-DD, time: HH:mm }
      if (!value) return { date: "", time: "" };
      const d = new Date(value);
      if (isNaN(d.getTime())) {
        const normalized = String(value).replace(" ", "T");
        return {
          date: normalized.length >= 10 ? normalized.substring(0, 10) : "",
          time: normalized.length >= 16 ? normalized.substring(11, 16) : ""
        };
      }
      const pad = (n) => String(n).padStart(2, "0");
      return {
        date: d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()),
        time: pad(d.getHours()) + ":" + pad(d.getMinutes())
      };
    },
    buildDateTime(date, time) {
      if (!date) return "";
      return date + "T" + (time || "00:00");
    },
    open_edit_modal(item) {
      const startParts = this.splitDateTimeParts(item.registration_start);
      const endParts = this.splitDateTimeParts(item.registration_end);
      this.edit_modal.event_key = item.event_key;
      this.edit_modal.title = item.title;
      this.edit_modal.event_date = this.toDateInput(item.event_date);
      this.edit_modal.registration_start_date = startParts.date;
      this.edit_modal.registration_start_time = startParts.time;
      this.edit_modal.registration_end_date = endParts.date;
      this.edit_modal.registration_end_time = endParts.time;
      this.edit_modal.is_saving = "N";
      this.edit_modal.show = true;
    },
    close_edit_modal() {
      this.edit_modal.show = false;
    },
    async clear_api_cache() {
      try {
        const headers = {
          'Authorization': 'Bearer ' + this.token,
          'Content-Type': 'application/json'
        };
        await axios.post("v1/utils/cache", {}, { headers });
      } catch (e) {
        console.error("clear cache error:", e);
      }
    },
    async save_edit_event() {
      if (!this.edit_modal.title) {
        alert("กรุณากรอกชื่อกิจกรรม");
        return;
      }
      if (!this.edit_modal.event_date) {
        alert("กรุณากรอกวันที่จัดกิจกรรม");
        return;
      }
      this.edit_modal.is_saving = "Y";
      const headers = {
        'Authorization': 'Bearer ' + this.token
      };
      const data = {
        event_key: this.edit_modal.event_key,
        title: this.edit_modal.title,
        event_date: this.edit_modal.event_date,
        registration_start: this.buildDateTime(this.edit_modal.registration_start_date, this.edit_modal.registration_start_time),
        registration_end: this.buildDateTime(this.edit_modal.registration_end_date, this.edit_modal.registration_end_time)
      };
      try {
        const res = await axios.post("v1/organizer/update-event", data, { headers });
        if (res.data.status === "success") {
          // clear cache หลังบันทึกสำเร็จ
          await this.clear_api_cache();
          alert("บันทึกข้อมูลสำเร็จ");
          this.edit_modal.show = false;
          this.load_my_order();
        } else {
          alert("พบข้อผิดพลาด: " + res.data.message);
        }
      } catch (e) {
        alert("พบข้อผิดพลาด: " + (e.response?.data?.message || e.message));
      }
      this.edit_modal.is_saving = "N";
    }
  }
};
</script>
